const Form085EN = {
    stepName: {
        importantNotes: "Important Notes",
        schoolInformation: "School Information",
        studentContestants: "Student Contestants",
        personalParticularsOfCoachTeacher:
            "Personal Particulars of Coach Teacher",
        confirmation: "Confirmation",
    },

    label: {
        statement: {
            title: {
                title1: "Personal Information Collection Statement",
                title2: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
            },
            // note: {
            //     a: "The personal data provided in this form will be used by the Education Bureau for the purposes of processing applications for the competition, liaison and compiling statistics.",
            //     b: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
            //     c: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
            //     d: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
            //     e: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be addressed to the Gifted Education Section of the Education Bureau via email (",
            //     f: "exoge@edb.gov.hk",
            //     g: ").",
            //     h:"The EDB is committed to ensuring all personal data to be handled in accordance with the relevant provisions of the Personal Data (Privacy) Ordinance. For details, please refer to the “",
            //     i:"Education Bureau - Statement of Privacy Policy and Practices",
            //     j:"”",
            //     k:"For enquiries, please contact Mr Terence LO on 3698 3493 or email to ",
            //     k1:".",
            //     l:"https://www.edb.gov.hk/attachment/en/about-edb/info/privacy-statement/EDB_PDPO_e.pdf",
            //     m:"Schools shall inform students and their parents / guardians that in the course of the competition, the EDB and persons / parties authorised by the EDB may take photographs and videos which the student may appear in. The photographs and videos may be used for publicity purposes by the EDB in print or digitally. Schools or parents / guardians who have any concern about the arrangement may write to ",
            //     n:"cdoge6@edb.gov.hk",
            //     o:"."
            // },
            noteList: [
                {
                    text: "The personal data provided in this form will be used by the Education Bureau for the purposes of processing applications for the competition, liaison and compiling statistics.",
                },
                {
                    text: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
                },
                {
                    text: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
                },
                {
                    text: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
                },
                {
                    text: 'Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be addressed to the Gifted Education Section of the Education Bureau via email (<a href="mailto: exoge@edb.gov.hk">exoge@edb.gov.hk</a>).',
                },
                {
                    text: 'The EDB is committed to ensuring all personal data to be handled in accordance with the relevant provisions of the Personal Data (Privacy) Ordinance. For details, please refer to the "<a style="color: blue" href="https://www.edb.gov.hk/attachment/en/about-edb/info/privacy-statement/EDB_PDPO_e.pdf" target="_blank" rel="noopener noreferrer">Education Bureau - Statement of Privacy Policy and Practices</a>"',
                },
                {
                    text: 'For enquiries, please contact Mr Terence LO on 3698 3493 or email to <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>.',
                },
                {
                    text: 'Schools shall inform students and their parents / guardians that in the course of the competition, the EDB and persons / parties authorised by the EDB may take photographs and videos which the student may appear in. The photographs and videos may be used for publicity purposes by the EDB in print or digitally. Schools or parents / guardians who have any concern about the arrangement may write to <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>.',
                },
            ],
        },
        schoolInfo: {
            schoolName: "Name of School (English)",
            schoolNameOfChinese: "Name of School (Chinese)",
            schoolTelephoneNumber: "School Telephone Number",
            schoolFaxNumber: "School Fax Number",
        },
        studentContestants: {
            nameInEnglish: "Name in English",
            nameInChinese:
                "Name in Chinese(Please fill in “NIL” if not available)",
            level: "Level",
            levelValue: {
                primary1: "Primary 4",
                primary2: "Primary 5",
                primary3: "Primary 6",
            },
        },
        instructorInfo: {
            nameInEnglish: "Name in English",
            nameInChinese: "Name in Chinese",
            mobileNumber: "Mobile Number",
            emailAddress: "E-mail address",
            nameOfTheSchoolHead: "Name of the School Head",
        },
        title: {
            title1: "Eligibility",
            title2: "Note",
        },
        note: {
            note1: "1. Each school can only send one team to participate in the competition",
            note2: "2. Each team consists of 4 students. ",
            note3: "3. Primary 4 to 6 students are eligible to the competition. There is no limitation on the number of students for each level.",
            // note4: "(1) This competition is co-organised by the Gifted Education Section, Education Bureau and Hong Kong Federation of Education Workers.",
            // note5: "(2)	For enquiries, please contact Mr LO Wing Pun, Terence of the Gifted Education Section of the Education Bureau on 3698 3493 or ",
            // note5a: " by email.",
            // note6: "(2)	Video and photo shooting will be performed in each stage of competition and the ceremony.",
            // note7: "(3)	Please ensure all information is filled in correctly. The information collected will be printed on the corresponding certificates and booklets.",
            // note8: "(4)	All information related to this competition including the results and arrangements of the Heats, Final and Prize Presentation Ceremony will be uploaded to the competition webpage ",
            // note9: "(5)	Participating schools are required to check the competition webpage regularly for the updates. EDB will not send further notification.",
            // note10: ".",
            // lianjie: "http://www.edb.gov.hk/en/CPS-Pri",
        },
        errorMsg: {
            nameOfSchoolEN: "Please input a valid name of school (English)",
            nameOfSchoolCH: "Please input a valid name of school (Chinese)",
            tel: "Please input a valid telephone number",
            fax: "Please input a valid fax number",
            nameInEnglish: "Please input a valid name in English",
            nameInChinese: "name in Chinese",
            nameOfEnglish: "Please input a valid name of English",
            nameOfChinese: "Please input a valid name of Chinese",
            mobileTel: "Please input a valid mobile telephone number",
            required: "This field is required",
            numberType: "The field must be of type 'number'",
            min8: "Minimum = 8",
            max20: "Maximum = 20",
            characterType: "alphabets  / alpha-numeric / Chinese",
            min4: "Each team consists of 4 students.",
            emailType: "need to be match Email rules ",
        },
    },
};
export default Form085EN;
